import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Loja } from 'src/app/core/models/loja.model';
import { Produto } from 'src/app/core/models/produto.model';
import { AnexoUploadService } from 'src/app/core/services/anexo-upload.service';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-pedido-venda',
  templateUrl: './pedido-venda.component.html',
  styleUrls: ['./pedido-venda.component.scss']
})
export class PedidoVendaComponent implements OnInit {
  @Input() comboOutrosServicos: Produto[] = [];
  @Input() servicosAdicionados: Produto[] = [];
  @Input() laboratorioSelecionado: Loja | undefined;
  @Input() os_numero_readonly: boolean = false;
  @Input() anexosExistentes: any[] = [];

  @Input() dadosForm: any;

  @Output() NumeroOSChange = new EventEmitter<string>();
  @Output() removerAnexoExistente = new EventEmitter<any>();

  @ViewChild('fileUpload') fileUpload?: FileUpload;

  handlerChecarNumeroOS: any = null;

  constructor(private anexoUploadService: AnexoUploadService) { }

  ngOnInit(): void {
    this.dadosForm.oldNumeroOS = this.dadosForm.numeroOS;
  }

  checarNumeroOS() {
    const self = this;
    clearTimeout(this.handlerChecarNumeroOS);
    this.handlerChecarNumeroOS = setTimeout(() => {
      const numero = self.dadosForm.numeroOS;
      if (numero != self.dadosForm.oldNumeroOS) {
        self.dadosForm.oldNumeroOS = numero;
        self.NumeroOSChange.emit(numero);
      }
    }, 500);
  }

  async onAnexosSelect(event: any) {
    const files = Array.from(event.files) as File[];
    const quantidadeJaAnexada = (this.anexosExistentes?.length || 0) + (this.dadosForm.anexos?.length || 0);
    const novosAnexos = await this.anexoUploadService.processarSelecao(files, quantidadeJaAnexada);
    this.dadosForm.anexos = (this.dadosForm.anexos || []).concat(novosAnexos);
  }

  onAnexosRemove(event: any) {
    this.dadosForm.anexos = this.dadosForm.anexos?.filter((a: any) => a.ref != event.file);
  }

  onAnexosClear(event: any) {
    this.dadosForm.anexos = [];
  }

  limparAnexos() {
    this.fileUpload?.clear();
  }
}
